import { CommonOptionVM } from "@cmodules/checklist/assets/data/types/vm/template-builder/types/global-options"
import { FieldsBehaviour } from "@csrc/assets/data/constants/FieldsBehaviour"
import { BehaviouralRuleType } from "./asset-field"
import { IScoring } from "./asset"

export type SeparatorValue = '-' | '/' | '|' | '_'

export const ALLOWED_SEPARATORS: readonly SeparatorValue[] = ['-', '/', '|', '_'] as const

export class GlobalListOptionsVM extends CommonOptionVM {
  advanced?: boolean
  separator?: SeparatorValue
  label_field_keys?: string[]
  value_field_keys?: string[]
  global_list_uuid?: string
  global_list_id?: number | string
  hidden?: boolean
  field_type?: keyof typeof FieldsBehaviour
  value_type?: BehaviouralRuleType
  enable_score?: boolean;
  scoring?: IScoring;

  constructor(data: Partial<GlobalListOptionsVM> = {}) {
    super(data)
    this.advanced = data?.advanced ?? undefined
    this.hidden = data?.hidden ?? undefined
    this.separator = data?.separator ?? ('/' as SeparatorValue)
    this.label_field_keys = data?.label_field_keys ?? []
    this.value_field_keys = data?.value_field_keys ?? []
    this.global_list_uuid = data?.global_list_uuid ?? undefined
    this.global_list_id = data?.global_list_id ?? undefined
    this.field_type = data.field_type || undefined
    this.value_type = data.value_type || undefined
    this.enable_score = data.enable_score ?? false
    this.scoring = this.enable_score ? {
      min_point: this.scoring?.min_point ?? 0,
      max_point: this.scoring?.max_point ?? null,
      scoring_weight: this.scoring?.scoring_weight ?? 1
    } : undefined
  }

  validateData() {
    const errors: { key: string; error_message: string }[] = []

    if (this.global_list_uuid === null || this.global_list_uuid === undefined || this.global_list_uuid === '') {
      errors.push({ key: 'global_list_uuid', error_message: 'global_list_uuid is required' })
    }

    if (this.global_list_id === null || this.global_list_id === undefined || this.global_list_id === '') {
      errors.push({ key: 'global_list_id', error_message: 'global_list_id is required' })
    }

    if (this.advanced) {
      const allowedSeparators = new Set(ALLOWED_SEPARATORS)
      if (typeof this.separator !== 'string' || !allowedSeparators.has(this.separator as SeparatorValue)) {
        errors.push({ key: 'separator', error_message: 'separator must be one of "-", "/", "|", "_"' })
      }
      if (!Array.isArray(this.label_field_keys) || this.label_field_keys.length === 0) {
        errors.push({ key: 'label_field_keys', error_message: 'label_field_keys is required when advanced is true' })
      }
      if (!Array.isArray(this.value_field_keys) || this.value_field_keys.length === 0) {
        errors.push({ key: 'value_field_keys', error_message: 'value_field_keys is required when advanced is true' })
      }
      /**
       * ***### Need to add validation for field_type and value_type
       */
    }

    return {
      is_valid: errors.length === 0,
      errors
    }
  }
}

export default GlobalListOptionsVM